import * as React from 'react';
import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import Localize from 'app/src/localize/Localize';
import Format from 'app/src/data/Format';
import Decimal from 'app/src/data/base/Decimal';
import TerminalPayment from 'payments/TerminalPayment';
import GatewayConfig from 'app/src/data/models/GatewayConfig';
import PaymentAnalytics from 'app/src/payments/PaymentAnalytics';
import PaymentServiceAlert from 'app/src/controllers/payments/PaymentServiceAlert';
import { CardAmount } from './CardAmount';
import { usePaymentContext } from '../Store/PaymentState';
import { CreditCardTerminalList } from './CreditCardTerminalList';

export const CancelCardView = ({ onCreditDebitCancelled }: TSFixMe) => {
  return (
    <Flex flexWrap="wrap" py={1}>
      <Button fill onClick={onCreditDebitCancelled} aria-label="Cancel Button">
        {Localize.translate('Cancel')}
      </Button>
    </Flex>
  );
};

export const CardView = ({ goToPaymentDefaultView }: TSFixMe) => {
  const { saleManager, paymentProvider, selectedTerminalId } = usePaymentContext();
  const [cardTotal, setCardTotal] = React.useState(saleManager.pendingBalance);

  const [showPaymentTerminal, setShowPaymentTerminal] = React.useState(false);

  React.useEffect(() => {
    const internalShowPaymentTerminal =
      paymentProvider.activeGatewayHasConfiguredTerminals() ||
      paymentProvider.activeGatewaySupportsUSBSwipe();
    setShowPaymentTerminal(internalShowPaymentTerminal);
  }, [paymentProvider]);

  const startTerminalPayment = async ({ amount, manualEntry = false }: TSFixMe) => {
    PaymentAnalytics.trackPaymentEvent('Start/Retry payment', saleManager.sale.id, {
      amount: amount.toString(),
      isRetry: false,
      paymentProcessor: paymentProvider.activeGatewayProcessorType,
    });
    if (
      [GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS].includes(
        paymentProvider.activeGateway.get('gatewayID')
      )
    ) {
      let currTerminalId = selectedTerminalId;
      // TODO:
      if (currTerminalId && currTerminalId.match && !currTerminalId.match(/-/)) {
        // the ID may be a UUID for certain types of terminals (e.g. Blackline)
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
        currTerminalId = Format.parseInt(selectedTerminalId, undefined);
      }

      const currSelectedTerminal = paymentProvider.getTerminal(currTerminalId);
      try {
        await TerminalPayment.doTerminalPayment({
          initialAmount: amount,
          terminal: currSelectedTerminal,
          saleManager,
          paymentProvider,
          isManualEntry: manualEntry,
          isUnreferencedRefund: false,
          recoveredPayment: null,
          refundedPaymentID: null,
        });
        goToPaymentDefaultView();
      } catch (errorMessage) {
        PaymentServiceAlert.alert(Localize.translate(errorMessage));
      }
    } else {
      PaymentServiceAlert.alert(
        Localize.translate('We currently only support Lightspeed payments')
      );
    }
  };

  const onStartPaymentButtonClicked = () => {
    const amountEntered = Format.parseDecimal(cardTotal, new Decimal(0));

    if (amountEntered.isZero()) {
      PaymentServiceAlert.warn(Localize.translate('Please enter a proper charge amount'));
    } else if (selectedTerminalId === 'select-terminal') {
      PaymentServiceAlert.warn(Localize.translate('Please select a terminal'));
    } else {
      startTerminalPayment({
        amount: amountEntered,
      });
    }
  };

  return (
    <>
      <CardAmount cardTotal={cardTotal} setCardTotal={setCardTotal} />
      {showPaymentTerminal && (
        <div id="payment_terminal_select" aria-label="payment_terminal_select">
          <Flex flexWrap="wrap" py={1}>
            <span>{Localize.translate('2. Payment Terminal')}</span>
          </Flex>
          <CreditCardTerminalList />
          <Flex flexWrap="wrap" py={1}>
            <Button
              fill
              onClick={onStartPaymentButtonClicked}
              id="emv_payment_start"
              aria-label="start payment Button"
            >
              {Localize.translate('Start Payment')}
            </Button>
          </Flex>
        </div>
      )}
    </>
  );
};
